import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const InformationGatheringHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 200 },
    children: [
        new TextRun({
            text: "Information Gathering",
            size: 24,
            color: "003366",
            font: "Calibri",
            bold: true,
            italics: false
        })
    ],
})

export const InformationGatheringText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The objective of this phase is to get better understanding of the applications which helps in identifying business risks and possible threats to the application. It is carried out through discussion with the application owners to know more about application, its features, functionalities, critical transactions, sensitive information and its end users etc.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const InformationBulletOne = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 350 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Understating the application & its features",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})

export const InformationBulletTwo = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 200 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identify Security Code Review Objectives",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})

export const InformationBulletThree = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 200 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Understanding the business criticality to the organization",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})

export const InformationBulletFour = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 200 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identifying critical and sensitive information it is handling",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})
export const InformationBulletFive = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 200 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identifying its end users",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})
export const ApplicationThreatModellingHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 350 },
    children: [
        new TextRun({
            text: "Application Threat Modelling",
            size: 24,
            color: "003366",
            font: "Calibri",
            bold: true,
            italics: false
        })
    ],
})

export const ApplicationThreatModellingText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 250 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "During this phase We consultants would closely review the Internet point of presence of infrastructure to get a better understanding and finalize application assessment objectives. Below listed activities would be carried out during the threat modeling phase",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),

    ],


})
export const overviewText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 100 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "Get application overview (Business and Technical)",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false
        }),
    ],
})

export const applicationBulletOne = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Understand and note systems functionality / component segregation",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})
export const applicationBulletTwo = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Interfacing layers and protocols",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})

export const applicationBulletThree = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Deployment and configurations requirements. ",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})

export const applicationBulletFour = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identification of technical components supporting the application and its associated interfaces",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})


export const applicationBulletFive = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1200, right: 300 },
    spacing: { before: 150, line: 350 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Information gathered above would be analyzed to identify threats and associated vulnerabilities within system components and its interfaces",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})


export const applicationBulletSix = new Paragraph({
    indent: { left: 1200 },
    spacing: { before: 150 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Identification of security test cases",
            size: 24,
            color: "0f0f3f",
            font: "Calibri",
            bold: false,
            italics: false
        })
    ],
})